import Request from './Request';
import {GROUP_FACEMATCH_STATES, GROUP_STATES} from "../helpers/constants";

const arrayToQuery = (propName, array = []) => {
    return array.reduce((acc, val) => {
        const pref = acc.length ? '&' : '';
        const addStr = val ? `${pref}${propName}=${val}` : '';
        return `${acc}${addStr}`;
    }, '')
};

const makeQueryFromArrays = (params) => {
    return params.reduce((acc, param, idx) => {
        if (!param[1].length) return acc;
        const suf = idx === params.length - 1 ? '' : '&';
        return `${acc}${arrayToQuery(...param)}${suf}`
    }, '')
};

class ApplicationService extends Request {
    constructor() {
        super('application');
    }

    completeApplication(uuId) {
        const options = {
            method: 'POST',
            body: JSON.stringify({ applicationUuId: uuId}),
        };
        return this.send({path: '/complete', options}).then(({json}) => json);
    }

    generateCode(uuId, type) {
        const options = {
            method: 'POST',
            body: JSON.stringify({
                applicationUuId: uuId,
                verificationType: 'LOAN_VERIFICATION',
                verificationChannel: type
            }),
        };
        return this.send({path: '/generate/code', options}).then(({json}) => json);
    }

    identifyCode(uuId, code) {
        const options = {
            method: 'POST',
            body: JSON.stringify({
                applicationUuId: uuId,
                code: code
            }),
        };

        return this.send({path: '/identify/code', options}).then(({ json }) => json);
    }

    printPdf(uuId) {
        const options = {
            method: 'POST',
            body: JSON.stringify({
                applicationUuId: uuId,
            }),
        };

        return this.send({path: '/print', options}).then(({json}) => json);
    }

    _getApplicationDetails(uuId) {
        const options = {
            method: 'GET',
        };
        return this.send({path: `/details/${uuId}`, options}).then(({ json }) => json);
    }

    getPdf(url) {
        const options = {
            method: 'GET',
        };

        return this.sendPdf({path: `${url}`, options}).then((res) => res);
    }

    _getApplication(uuId) {
        const options = {
            method: 'GET',
        }
        return this.send({path: `/${uuId}`, options}).then(({json}) => json)
    }

    getApplication(uuId) {
        return Promise.all([this._getApplication(uuId), this._getApplicationDetails(uuId)]).then(([app, details]) => (
            {...details, generalSheetUrl: app.generalSheetUrl}
        ))
    }

    getApplications({branches = [], status, states = [], terms = [], createdAfter, createdBefore}) {
        const options = {
            method: 'GET',
        };

        if (states.length && states[0].includes('GROUP')) {
            states[0] = [...states[0], ...GROUP_STATES]
        }

        if (states.length && states[0].includes('GROUP_FACEMATCH')) {
            states[0] = [...states[0], ...GROUP_FACEMATCH_STATES]
        }

        if (states.length && states[0].includes('ALL')) {
            states[0] = [];
        }

        let query = makeQueryFromArrays([
            ['merchantBranches', branches],
            ['states', states],
            ['statuses', status ? [status] : []],
            ['terms', terms],
            ['createdAfter', createdAfter ? [createdAfter] : []],
            ['createdBefore', createdBefore ? [createdBefore] : []],
        ]);

        if (query.includes('GROUP,')) {
            query = query.replace('GROUP,', '');
        }

        if (query.includes('GROUP_FACEMATCH,')) {
            query = query.replace('GROUP_FACEMATCH,', '');
        }

        return this.send({path: `/detailed/search?${query}`, options}, () => {
            return {json: {applications: []}}
        }).then(({json}) => json)
    }

    deny(uuId, { state, reason, otherReasonMessage }) {
        const options = {
            method: 'POST',
            body: JSON.stringify({ applicationUuId: uuId, state, reason, otherReasonMessage}),
        };
        return this.send({path: '/deny', options}).then(({json}) => json);
    }
}

export default new ApplicationService();